// require('dotenv').config();
// import 'dotenv/config';
export const environment = {
  production: false,
  application:
  {
    name: 'angular-starter',
    angular: 'Angular 11.2.0',
    fontawesome: 'Font Awesome 5.15.2',
  },
  // baseMuseumUrl: process.env.BASE_MUSEUM_URL || 'http://elle.com'
  //baseMuseumUrl: 'http://elle.com/museum/frames/'
  // 'https://ellesdafrique.fr/museum/frames/'
  baseMuseumUrl: window['env']['webapiEndpoint'] || "https://ellesdafrique.fr/museum/frames/"
};
// console.log('process.env.DB_HOST', process.env.BASE_MUSEUM_URL)
